import { useEffect, useState } from 'react';

import { Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { useNguoiDanhBa } from '../../hooks/useNhiemVu';
import type { NguoiDanhBa } from '../../types-nhiem-vu';

const TRE_TIM_MS = 300;

interface Props {
  id?: string;
  excludeIds: string[];
  onPick: (user: NguoiDanhBa) => void;
  invalid?: boolean;
  autoFocus?: boolean;
  size?: 'small' | 'middle';
}

/** Ô tìm người trong danh bạ của module; chọn xong tự xoá ô để chọn tiếp. */
export function UserSearchSelect({ id, excludeIds, onPick, invalid, autoFocus, size }: Props) {
  const { t } = useT();
  const [input, setInput] = useState('');
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hen = setTimeout(() => setSearch(input.trim()), TRE_TIM_MS);
    return () => clearTimeout(hen);
  }, [input]);

  const users = useNguoiDanhBa(search, open);
  const bo = new Set(excludeIds);
  const options = (users.data ?? [])
    .filter((u) => !bo.has(u.id))
    .map((u) => ({ value: u.id, label: u.email ? `${u.full_name} · ${u.email}` : u.full_name }));

  return (
    <Select<string | null>
      id={id}
      showSearch={{ filterOption: false, searchValue: input, onSearch: setInput }}
      autoFocus={autoFocus}
      size={size}
      className="w-full"
      status={invalid ? 'error' : undefined}
      value={null}
      aria-label={t('vanBanNhiemVu.form.timNguoi')}
      placeholder={t('vanBanNhiemVu.form.timNguoi')}
      onOpenChange={setOpen}
      onChange={(userId) => {
        const user = users.data?.find((u) => u.id === userId);
        if (!user) return;
        onPick(user);
        setInput('');
      }}
      loading={users.isFetching}
      notFoundContent={users.isFetching ? null : t('vanBanNhiemVu.form.khongThayNguoi')}
      options={options}
    />
  );
}
